var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.$store.getters.getGraphqlErrors),function(error,i){return _c('v-snackbar',{key:error.key,style:({top: '-'+(50 * i+1) + 'px' }),attrs:{"color":"red","bottom":"","right":"","value":true,"timeout":_vm.timeout}},[_vm._v(" "+_vm._s(_vm.getMessage(error))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }